import {init} from '../common/spotify'
import {getToken, refreshToken} from './api'

const SPOTIFY_CLIENT_ID = process.env.REACT_APP_SPOTIFY_CLIENT_ID || ''
const SPOTIFY_SCOPES =
  'user-read-playback-state user-modify-playback-state playlist-modify-public playlist-modify-private'
const REDIRECT = process.env.REACT_APP_URL

const getRedirectURL = () => {
  return REDIRECT ?? window.location.origin
}

export const getAuthUrl = (
  redirect = getRedirectURL(),
  clientId?: string,
  scope?: string
) =>
  'https://accounts.spotify.com/authorize?' +
  new URLSearchParams({
    client_id: clientId ?? SPOTIFY_CLIENT_ID,
    response_type: 'code',
    redirect_uri: redirect,
    scope: scope ?? SPOTIFY_SCOPES
  })

export const Spotify = init(getToken, refreshToken)
